import { useBooleanFlagValue } from '@openfeature/react-sdk';

import { APPLE_IAP_COMPLIANCE_FLAG_KEY, isMAS } from '@/utils/appConfiguration';

/**
 * Reactive version of `isAppleCompliantBuild` for use inside React components:
 * it re-renders when the Flagsmith flag value changes (remote refresh, dev-tools
 * override), so the kill-switch works without an app restart. Use it wherever the
 * result gates JSX; the plain `isAppleCompliantBuild()` is fine for event handlers.
 *
 * Kept out of `appConfiguration.ts` on purpose: that module is pulled into the
 * server/edge bundle via `logger`, and `@openfeature/react-sdk` can't be evaluated
 * there (pulling it in forces a webpack CJS alias for the edge build).
 * `appConfiguration` uses the framework-agnostic `@openfeature/web-sdk` instead.
 */
export function useIsAppleCompliantBuild(): boolean {
  const flagEnabled = useBooleanFlagValue(APPLE_IAP_COMPLIANCE_FLAG_KEY, false);
  return isMAS() && flagEnabled;
}
